import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IBasicDetails, IDashboardStatusBarInput } from '../../../../interface/interfaces';

interface IInitialState {
    dashboardStatusBarLoading: boolean;
    dashboardStatusBarData: IBasicDetails[];
    dashboardStatusBarError: string;
}


const initialState: IInitialState = {
    dashboardStatusBarLoading: false,
    dashboardStatusBarData: [],
    dashboardStatusBarError: '',
};

const dashboardStatusBarSlice = createSlice({
    name: 'dashboardStatusBar',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        dashboardStatusBarPending: (state: IInitialState, action: PayloadAction<IDashboardStatusBarInput>) => {
            state.dashboardStatusBarLoading = true;
            state.dashboardStatusBarError = '';
        },

        dashboardStatusBarFulfilled: (state: IInitialState, action: PayloadAction<IBasicDetails[]>) => {
            state.dashboardStatusBarLoading = false;
            state.dashboardStatusBarData = action.payload;
            state.dashboardStatusBarError = '';
        },

        dashboardStatusBarFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.dashboardStatusBarLoading = false;
            state.dashboardStatusBarData = [];
            state.dashboardStatusBarError = action.payload;
        },
    },
});

export default dashboardStatusBarSlice.reducer;
export const { dashboardStatusBarPending, dashboardStatusBarFulfilled, dashboardStatusBarFailure } = dashboardStatusBarSlice.actions;
